import { render } from "./HeroiconsOutlineFingerPrint.vue?vue&type=template&id=ef400314"
const script = {}

import exportComponent from "/Users/danielarabia/code/rea-nova/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineFingerPrint.vue"]])

export default __exports__